import api from "./api";
const { vendorServiceAPI, pimcoreServiceAPI } = api;

const VENDOR_CONTACT_LIST_PATH = "/vendorContact/list";
const VENDOR_CONTACT_GROUP_VENDOR_LIST_PATH = "/vendorContact/vendorList";
const VENDOR_CONTACT_CREATE_PATH = "/vendorContact";
const VENDOR_SITE_LIST_PATH = "vendorContact/manufacturing-sites/";
const VENDOR_CONTACT_PATH = "/vendorContact/";
const GET_TRANSITION_OBJECT_PATH = "/workFlow/enabledTransitions/";
const APPLY_TRANSITION_PATH = "/workFlow/applyTransitions";

const VendorContacService = {

    getVendorContactList: async () => {
        try {
          const resp = await vendorServiceAPI.get(VENDOR_CONTACT_LIST_PATH);
          return resp.data;
        } catch (error) {
          throw error;
        }
      },
    getVendorContactGroupVendorList: async () => {
        try {
          const resp = await vendorServiceAPI.get(VENDOR_CONTACT_GROUP_VENDOR_LIST_PATH);
          return resp.data;
        } catch (error) {
          throw error;
        }
    },
    createVendorContact: async (payload: any) => {
        try {
          const resp = await vendorServiceAPI.post(VENDOR_CONTACT_CREATE_PATH, payload);
          return resp.data;
        } catch (error) {
          throw error;
        }
    },
    getvendorSiteDropdownList: async (
        id: number,
        options?: { assessmentId?: string }
    ) => {
        try {
          const hasAssessmentId =
            options?.assessmentId != null && String(options.assessmentId).trim() !== "";
          const config = hasAssessmentId
            ? { params: { assessmentId: String(options?.assessmentId).trim() } }
            : undefined;
          const resp = await vendorServiceAPI.get(VENDOR_SITE_LIST_PATH + id, config);
          return resp.data;
        } catch (error) {
          throw error;
        }
    },
    getVendorContact: async (id: number) => {
        try {
          const resp = await vendorServiceAPI.get(VENDOR_CONTACT_PATH + id);
          return resp.data;
        } catch (error) {
          throw error;
        }
    },
    updateVendorContact: async (id: number, payload: any) => {
        try {
          const resp = await vendorServiceAPI.put(VENDOR_CONTACT_PATH + id, payload);
          return resp.data;
        } catch (error) {
          throw error;
        }
    },
    deleteVendorContact: async (id: number) => {
        try {
          const resp = await vendorServiceAPI.delete(VENDOR_CONTACT_PATH + id);
          return resp.data;
        } catch (error) {
          throw error;
        }
    },
    getTransitionObject: async (objectId: string) => {
      try {
        const resp = await pimcoreServiceAPI.get(GET_TRANSITION_OBJECT_PATH + objectId);
        return resp.data;
      } catch (error) {
        throw error;
      }
  },
  applyTransition: async ( payload: any) => {
    try {
      const resp = await pimcoreServiceAPI.post(APPLY_TRANSITION_PATH, payload);
      return resp.data;
    } catch (error) {
      throw error;
    }
},
};

export default VendorContacService;
